<template>
  <dv-border-box-3 class="rmctc-chart-1">
    <div class="bottom_wrapper" >
      <div class="chart">区域统计</div>
      <div class="right_table_container">
        <dv-scroll-board :config="areaTableConfig" class="right_table" v-if="areaData.data.length != 0"/>
        <div v-else class="no_data_container">
          <svg t="1734682816221" class="icon mt_30" viewBox="0 0 1296 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="28578" width="64" height="64"><path d="M0.005098 891.731839c-0.487398 72.948658 277.727177 132.174169 621.422942 132.272543s622.706274-58.943804 623.193672-131.910348v-0.384552c0.487398-72.948658-277.73612-132.174169-621.427415-132.272543S0.50591 818.3718 0.005098 891.329401z" fill="#D5EBFF" opacity=".504" p-id="28579"></path><path d="M631.319081 296.453975l-433.8509 108.211201 12.967458 246.520318 420.883442-110.151848 420.887912 110.165263V404.67859z" fill="#82BFFB" p-id="28580"></path><path d="M978.377442 319.755155c0-42.03245-34.775145-42.452774-46.544231-21.977605a1213.79878 1213.79878 0 0 0-119.421344 292.827558q-52.178368 195.254144-178.982221 234.983753-263.945899-40.972696-385.795288-133.564817c104.244947-41.728385 126.464016-92.189683 152.631451-158.046483s28.112555-274.377996 148.808287-368.754261c72.474675-56.66332 224.918322-3.501214 400.059493 52.683652 16.781679 5.374788 112.168511 12.752824 29.243853 101.848203z" fill="#C9E5FF" p-id="28581"></path><path d="M1018.786724 297.348282q-4.207717 34.332463-6.863809 44.800332c-3.331295 13.101604-12.310142 20.251592-21.463379 28.049953-28.058896 23.936139-70.869393 40.856436-113.751436 36.290996 5.687795-12.354857 12.184939-27.347922 26.444672-55.894215 6.389827-12.810954 11.28616-33.330838 21.651183-53.658447 13.830465 8.630067 20.367852 4.095928 45.569436 4.095928a311.218991 311.218991 0 0 0 48.413333-3.684547z" fill="#98CDFF" opacity=".44" p-id="28582"></path><path d="M893.261731 371.781491q29.619463-85.16937 37.274735-102.939258c11.389005-26.435728 26.829223-37.788961 53.054789-37.788962s59.958843 49.3926 25.984103 117.954681c-7.15446-17.912978-40.382453-34.350349-66.487287-27.826376q-26.100363 6.501615-49.844226 50.608858z m-49.812924-71.839717q-34.998722 51.521052-34.998722 90.012044-39.541804-12.967458-92.757568-25.380445a195.1826 195.1826 0 0 1 8.048767-41.585296 185.568795 185.568795 0 0 1 20.738989-45.833257l98.973005 22.782482z m-162.866801-36.908068l-118.603053-22.97923a12.234126 12.234126 0 0 0-14.308919 9.676406l-0.366666 1.833331a12.229654 12.229654 0 0 0 9.685349 14.358106l118.603054 22.988173a12.229654 12.229654 0 0 0 14.34022-9.676407l0.353251-1.83333a12.234126 12.234126 0 0 0-9.671935-14.349163z m-13.204449 39.510503l-118.603054-22.97923a12.234126 12.234126 0 0 0-14.335748 9.662992l-0.357723 1.851216a12.234126 12.234126 0 0 0 9.676407 14.349163l118.611996 22.97923a12.234126 12.234126 0 0 0 14.335748-9.662992l0.366666-1.842273a12.229654 12.229654 0 0 0-9.685349-14.358106z" fill="#98CDFF" p-id="28583"></path><path d="M799.659043 448.77689l-298.296249-57.794618a9.882097 9.882097 0 0 0-3.778449 19.393057l298.278362 57.79909a9.873154 9.873154 0 1 0 3.782921-19.379642z m-21.543867 51.641784l-291.808048-56.556003a9.882097 9.882097 0 1 0-3.78292 19.393057l291.799105 56.551531a9.877626 9.877626 0 1 0 3.778449-19.388585z m-81.717343 39.90847l-226.957343-43.982041a9.877626 9.877626 0 1 0-3.78292 19.388586l226.961814 43.973097a9.873154 9.873154 0 1 0 3.782921-19.379642z m-66.724278 57.052343l-181.584655-35.195469a9.89104 9.89104 0 0 0-3.782921 19.393056l181.589127 35.190998a9.877626 9.877626 0 1 0 3.78292-19.388585z m86.059205 74.0576L423.924713 614.881084a9.877626 9.877626 0 0 0-3.778449 19.388585l291.808047 56.551531a9.873154 9.873154 0 0 0 3.778449-19.379642z" fill="#FFFFFF" p-id="28584"></path><path d="M284.96275 61.962091a12.82884 12.82884 0 0 1 12.842255 12.828841v76.118978a12.842255 12.842255 0 0 1-25.688981 0V74.790932a12.82884 12.82884 0 0 1 12.842255-12.828841zM151.496307 192.191141h76.127921a12.842255 12.842255 0 0 1 0 25.680039H151.496307a12.842255 12.842255 0 1 1 0-25.688982z m28.899545-70.158419a12.967458 12.967458 0 0 1 18.270701-18.333302l53.658447 54.1056a12.967458 12.967458 0 0 1-18.333303 18.333303l-53.577959-54.105601z" fill="#E1F0FF" p-id="28585"></path><path d="M212.738481 859.478641a35.870672 35.870672 0 0 1-26.346297-33.536529l11.08494-421.218806 421.813521 111.824203v447.301283L212.729538 859.47417z" fill="#82BFFB" p-id="28586"></path><path d="M512.438792 740.571524l-354.338024-93.298625a34.560511 34.560511 0 0 1-24.37435-42.926757L197.468181 404.674119l421.826936 111.967292-65.610866 201.527711a35.772298 35.772298 0 0 1-41.245459 22.39793" fill="#ABD4FC" p-id="28587"></path><path d="M619.299589 963.857735l406.561107-104.374622a35.870672 35.870672 0 0 0 26.350769-33.536529v-421.218807l-432.911876 111.824203v447.296812z" fill="#1D89F7" p-id="28588"></path><path d="M1080.498409 647.277371a34.569454 34.569454 0 0 0 24.378821-42.926757l-52.665765-199.672024-432.911876 111.967292 59.994614 199.654138a36.304411 36.304411 0 0 0 43.119034 24.258089l358.089644-93.298624z" fill="#ABD4FC" p-id="28589"></path><path d="M20.699372 658.094019l-12.073151-12.046321a6.260152 6.260152 0 1 1 8.799986-8.799985l12.041849 12.046321 12.462175-12.462174a7.020313 7.020313 0 1 1 9.922341 9.922341l-12.462175 12.462174 10.624373 10.624373a6.260152 6.260152 0 1 1-8.791042 8.799985l-10.61543-10.610958-10.999981 10.991039a7.015842 7.015842 0 1 1-9.913398-9.922341z" fill="#E1F0FF" opacity=".464" p-id="28590"></path><path d="M1167.205988 165.393219l-11.138599-11.733314a9.028034 9.028034 0 0 1 0-13.034531 9.363399 9.363399 0 0 1 13.61583 0l11.1386 11.733314 11.138599-11.733314a9.363399 9.363399 0 0 1 13.615831 0 9.014619 9.014619 0 0 1 0 13.034531l-11.1386 11.733314 11.1386 11.728842a9.023562 9.023562 0 0 1 0 13.043474c-2.477232 1.301217-3.715847 2.597963-6.193079 2.597963a9.229253 9.229253 0 0 1-6.184136-2.597963l-11.1386-11.7512-11.138599 11.733314a8.665839 8.665839 0 0 1-12.377215 0 9.023562 9.023562 0 0 1 0-13.043474z m-403.806641-105.264458a30.062145 30.062145 0 1 1 0-60.128761 30.062145 30.062145 0 1 1 0 60.128761z m0-42.095051a11.362176 11.362176 0 0 0-12.023963 12.023963 12.019492 12.019492 0 1 0 24.043455 0 11.362176 11.362176 0 0 0-12.019492-12.023963z m499.376806 641.392828a33.679618 33.679618 0 1 0-33.760106-33.68409 33.715391 33.715391 0 0 0 33.760106 33.68409z m0-14.680057a19.004033 19.004033 0 1 1 0-38.008067 19.004033 19.004033 0 1 1 0 38.008067z" fill="#E1F0FF" p-id="28591"></path></svg>
          <div class="no_data_text">无数据</div>
        </div>
      </div>
    </div>
  </dv-border-box-3>
</template>

<script>
export default {
  name: 'RightChart',
  props: {
    areaData: {
      required: true,
      type: Object
    },
    windowWidth:{
      required: true,
      type: Number
    }
  },
  data() {
    return {
      areaTableConfig: {
        columnWidth: [200],
        data:[],
        rowNum:10
      },
    }
  },
  methods:{
    refreshData() {
      this.areaTableConfig = {
        columnWidth: [200],
        data: this.areaData.data,
        rowNum:10
      }
    }
  }
}
</script>

<style lang="less" scoped>
.rmctc-chart-1 {
  height: 100%;
  /deep/ .border-box-content {
    flex-direction: column;
    display: flex;
    height:100% !important;
  }

  .ml_20{
    margin-left:1vw
  }
  .ml_10{
    margin-left:0.5vw
  }
  .ml_5{
    margin-left:0.3vw
  }
  .pt_5 {
    padding-top:5px;
  }
  .line{
    height:1px;
  }


  .bottom_wrapper{
    height:100%;
    .right_table_container{
      width: 90%;
      height: 90%;
      display: flex;
      flex-grow: 0;
      flex-direction: row;
      color:#67abf4;
      margin: 5%;
      .right_table{
        width: 100%;
        height: 90%;
      }
    }
    .chart{
      height: 6%;
      text-align: center;
      line-height: 4vh;
      font-size: 1.1vw;
      margin-top: 2vh;
      color:#67abf4;
      font-weight: bolder
    }
    .loading-container{
      width:100%;
      height:90%;
    }
    .no_data_container{
      width: 100%;
      text-align: center;
      margin-top: 6vh;
      .no_data_text{
        font-weight: normal;
        margin-top: 1vh;
        color:#18cce9;
        font-size: 0.8vw;
      }
    }
  }

}
</style>
